import ImageLink from './ImageLink'

export default ImageLink
